module.exports = __webpack_public_path__ + "static/media/1.127cf55c.png";